import React from 'react';
import {
  Box,
  Paper,
  Typography,
  Stack,
  IconButton,
  Chip,
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { DashboardWidgetData } from '../../Dashboard/components/CustomChartWidget';
import { SourceField } from '../types';

interface WidgetRowProps {
  widget: DashboardWidgetData;
  sourceFields: SourceField[];
  onEdit: (widget: DashboardWidgetData) => void;
  onDelete: (widget: DashboardWidgetData) => void;
  onPreview: (widget: DashboardWidgetData) => void;
}

const fieldLabelFor = (fieldId: string, sourceFields: SourceField[]): string => {
  const match = sourceFields.find((f) => f.fieldId === fieldId);
  return match?.label || '(missing field)';
};

export const WidgetRow: React.FC<WidgetRowProps> = ({
  widget,
  sourceFields,
  onEdit,
  onDelete,
  onPreview,
}) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, flexWrap: 'wrap' }}>
        <Box sx={{ flexGrow: 1, minWidth: 200 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
            {widget.title}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {widget.isSystem ? (
              <>
                System widget · {widget.chartType} · {widget.aggregation}
                <Chip label="System" color="info" size="small" sx={{ ml: 1 }} />
              </>
            ) : (
              <>
                {fieldLabelFor(widget.fieldId, sourceFields)} · {widget.chartType} · {widget.aggregation}
              </>
            )}
          </Typography>
        </Box>
        <Stack direction="row" spacing={1} alignItems="center">
          <IconButton size="small" onClick={() => onPreview(widget)} aria-label="Preview widget">
            <VisibilityIcon fontSize="small" />
          </IconButton>
          {!widget.isSystem && (
            <IconButton size="small" onClick={() => onEdit(widget)} aria-label="Edit widget">
              <EditIcon fontSize="small" />
            </IconButton>
          )}
          {!widget.isSystem ? (
            <IconButton size="small" color="error" onClick={() => onDelete(widget)} aria-label="Delete widget">
              <DeleteIcon fontSize="small" />
            </IconButton>
          ) : (
            <Chip label="System" color="info" size="small" />
          )}
        </Stack>
      </Box>
    </Paper>
  );
};

export default WidgetRow;
